import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

const RadioOptions = ({ options, handleChange, value }) => {
  return (
    <FormControl component="fieldset">
      <RadioGroup
        aria-label="valuation"
        name="valuation"
        onChange={handleChange}
        value={value}>
        {options.map((option, i) => (
          <FormControlLabel control={<Radio />} label={option} value={option} />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioOptions;
